<template>
    <div id="secondBack">

        <div class="section3">
            <h4>【1】刷新复机配置</h4>
            <el-row>
                <el-col :span="7">
                    <label style="width:120px;">用户是否可用：</label>
                    <el-select v-model="isUserOpen" placeholder="请选择">
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="0"></el-option>
                    </el-select>
                </el-col>

                <el-col :span="7">
                    <label style="width:120px;">管理员是否可用：</label>
                    <el-select v-model="isAdminOpen" placeholder="请选择">
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="0"></el-option>
                    </el-select>
                </el-col>

                <el-col :span="6">
                    <label>距离月底几天不可用(未充值次月)：</label>
                    <el-input-number v-model="day" :min="1" :max="365" label="请输入"></el-input-number>
                </el-col>

                <el-col :span="1">
                    <el-button type="primary" @click="secondBackDiagnoseHandler">更新</el-button>
                </el-col>

            </el-row>

        </div>

        <!-- <div class="section1">
            <h4>【2】 秒返设置</h4>
            <el-row >
                <el-col :span="5">
                    <label>秒返设置：</label>
                    <el-radio-group v-model="secondBackState">
                        <el-radio label="1">开启</el-radio>
                        <el-radio label="0">停用</el-radio>
                    </el-radio-group>
                </el-col> 
                <el-col :span="5">
                    <label>每日代理商返秒返订单数：</label>
                    <el-input-number v-model="dayOfBack" :min="-1" ></el-input-number>
                </el-col> 

                <el-col :span="5">
                    <label>金额大于多少返佣金(角)：</label>
                    <el-input-number v-model="maxMoney" :min="5"  ></el-input-number>
                </el-col>

                <el-col :span="1">
                    <el-button type="primary"  @click="updateSecondBackStateHandler">更新</el-button>
                </el-col>

            </el-row>
        </div> -->

        <div class="section1">
            <h4>【2】 换卡邮费设置</h4>
            <el-row>
                <el-col :span="5">
                    <label>是否开启邮费：</label>
                    <el-radio-group v-model="postageForm.is_enable">
                        <el-radio label="1">开启</el-radio>
                        <el-radio label="0">停用</el-radio>
                    </el-radio-group>
                </el-col>
                <el-col :span="5">
                    <label>是否充值自动退款：</label>
                    <el-radio-group v-model="postageForm.is_auto_back">
                        <el-radio label="1">开启</el-radio>
                        <el-radio label="0">停用</el-radio>
                    </el-radio-group>
                </el-col>

                <el-col :span="5">
                    <label>邮费(元)：</label>
                    <el-input-number v-model="postageForm.priceRmb" :min="0"></el-input-number>
                </el-col>

                <el-col :span="1">
                    <el-button type="primary" @click="updatePostageConfig()">更新</el-button>
                </el-col>

            </el-row>
        </div>



        <!-- <div class="section2">
            <h4>【4】 手机绑定设置</h4>
            <el-row>
                <el-col :span="5">
                    <label>手机绑定：</label>
                    <el-radio-group v-model="bindState">
                        <el-radio :label="2">开启</el-radio>
                        <el-radio :label="1">关闭</el-radio>
                    </el-radio-group>
                </el-col>

                <el-col :span="1">
                     <el-button type="primary"   @click="updateBindPhoneStateHandler">更新</el-button>
                </el-col>
            </el-row>
        </div> -->

        <!-- 
        <div class="section2">
            <h4>【5】 充值赠送优惠券</h4>
            <el-row>
                <el-col :span="5">
                    <label>启用充值赠送优惠券：</label>
                    <el-radio-group v-model="coupon.is_enable">
                        <el-radio :label="1">开启</el-radio>
                        <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                </el-col>

                <el-col :span="8">
                    <label style="width:150px;">赠送优惠券：</label>
                    <el-select
                     v-model="coupon"
                     clearable
                     filterable
                     remote
                     placeholder="请输入关键词"
                     :remote-method="remoteMethod"
                     :loading="loading"
                     default-first-option 
                     value-key="id"
                     >
                         <el-option v-for="item in couponList"  :key="item.id"  :label="item.title" :value="item">

                         </el-option>
                    </el-select>
                </el-col>


                <el-col :span="1">
                     <el-button type="primary" @click="updateCouponInfoHandler" >更新</el-button>
                </el-col>

            </el-row>
           
        </div> -->




        <div class="section2">
            <h4>【3】 支付通道配置</h4>
            <el-row>
                <el-col :span="3" v-for=" item in payChanle" :key="item.id">
                    <label>{{ item.alias }}: </label>&nbsp;
                    <el-switch v-model="item.enable"></el-switch>
                </el-col>

                <el-col :span="1">
                    <el-button type="primary" @click="updatePayChannel()">更新</el-button>
                </el-col>

            </el-row>

        </div>






        <div class="section3">
            <h4>【4】 收款配置</h4>
            <el-row>
                <el-col :span="12">
                    <label>公众APPID：</label>
                    <span>{{ collectionConfigShowData.wxAppId }}</span>
                </el-col>
                <el-col :span="12">
                    <label style="">公众号密钥：</label>
                    <span>{{ collectionConfigShowData.wxAppSecret }}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <label>商户号：</label>
                    <span>{{ collectionConfigShowData.wxMchId }}</span>
                </el-col>
                <el-col :span="12">
                    <label>商户密钥：</label>
                    <span>{{ collectionConfigShowData.wxKeySign }}</span>
                </el-col>

            </el-row>


            <el-row>
                <!-- <el-col :span="1">
                     <el-button type="primary" @click="addCollectionConfig()" >新增</el-button>
                </el-col> -->
                <el-col :span="1">
                    <el-button type="primary" @click="updateCollectionConfig()">编 辑</el-button>
                </el-col>
            </el-row>
        </div>

        <div class="section3">
            <h4>【4.1】 乐刷商户号配置 (乐刷商户编号-支付密钥，如：106888866-DB3DBAFD6F714614BBB4BFF03F1F4752)</h4>
            <el-row>

                <el-col :span="6">
                    <el-input v-model="leshuaId" label="请输入"></el-input>
                </el-col>


                <el-col :span="1">
                    <el-button type="primary" @click="updateFlowLimit()">更新</el-button>
                </el-col>
            </el-row>
        </div>

        <div class="section1">
            <h4>【4.2】 易支付配置</h4>
            <el-row>
                <el-col :span="7">
                    <label style="width:120px;">商户号：</label>
                    <el-input style="width:180px;" v-model="subId" placeholder="请输入"></el-input>
                </el-col>

                <el-col :span="7">
                    <label style="width:120px;">商户密钥：</label>
                    <el-input style="width:220px;" v-model="subKey" placeholder="请输入"></el-input>
                </el-col>
                <el-col :span="7">
                    <label style="width:120px;">支付域名：</label>
                    <el-input style="width:220px;" v-model="subPwd" placeholder="请输入"></el-input>
                </el-col>

                <el-col :span="1">
                    <el-button type="primary" @click="updateYy()">保 存</el-button>
                </el-col>
            </el-row>
        </div>



        <el-dialog :append-to-body="true" title="收款配置" :visible.sync="collectionConfigVisible" width="600px"
            :close-on-click-modal="false">

            <el-form :model="collectionConfigFormdata" :rules="collectionConfigRules" ref="collectionConfigForm"
                label-width="120px" class="demo-ruleForm">
                <el-form-item label="APPID：" prop="wxAppId">
                    <el-input v-model="collectionConfigFormdata.wxAppId"></el-input>
                </el-form-item>
                <el-form-item label="公众号密钥：" prop="wxAppSecret">
                    <el-input v-model="collectionConfigFormdata.wxAppSecret"></el-input>
                </el-form-item>
                <el-form-item label="商户号：" prop="wxMchId">
                    <el-input v-model="collectionConfigFormdata.wxMchId"></el-input>
                </el-form-item>
                <el-form-item label="商户密钥：" prop="wxKeySign">
                    <el-input v-model="collectionConfigFormdata.wxKeySign"></el-input>
                </el-form-item>

                <el-form-item label="公众号证书：">
                    <div class="toChooseFileBtn">配置公众号用（选填）</div>
                    <input multiple type="file" ref="file" id="secondBack-uploadFile" class="uploadFile"
                        @change="chooseFile($event)">
                    <p>
                        <span v-show="collectPkcsFileName == ''" style="color: #F56C6C;">未选择文件</span>
                        <span v-show="collectPkcsFileName != ''">已选择文件 {{ collectPkcsFileName }}</span>
                    </p>
                </el-form-item>

                <el-form-item label="P12证书：">
                    <div class="toChooseFileBtn">商户号退款用（P12重命名为：商户号.p12）</div>
                    <input multiple type="file" ref="file1" id="secondBack-uploadFile" class="uploadFile"
                        @change="chooseFile1($event)">
                    <p>
                        <span v-show="collectPkcsFileName1 == ''" style="color: #F56C6C;">未选择文件</span>
                        <span v-show="collectPkcsFileName1 != ''">已选择文件 {{ collectPkcsFileName1 }}</span>
                    </p>
                </el-form-item>
            </el-form>



            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelToSetCollectionConfig()">取 消</el-button>
                <el-button type="primary" @click="collectionConfigHandle()">保 存</el-button>
            </span>
        </el-dialog>






        <div class="section2">
            <h4>【5】 限制充值</h4>
            <el-row>
                <el-col :span="8">
                    <label>运营商：</label>
                    <el-select v-model="rechargePermissions.supplierIds" multiple filterable clearable placeholder="请选择"
                        style="width: 80%;">
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id"
                            :label="item.name + '(' + item.alias + ')'"></el-option>
                    </el-select>
                </el-col>

                <el-col :span="1">
                    <el-button type="primary" @click="updateRechargePermissions()">更新</el-button>
                </el-col>
            </el-row>
        </div>





        <div class="section2">
            <h4>【6】 余额充值限制</h4>
            <el-row>
                <el-col :span="8">
                    <label>运营商：</label>
                    <el-select v-model="balanceRechargeLimit.id" multiple filterable clearable placeholder="请选择"
                        style="width: 80%;">
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id"
                            :label="item.name + '(' + item.alias + ')'"></el-option>
                    </el-select>
                </el-col>

                <el-col :span="1">
                    <el-button type="primary" @click="updateBalanceRecharge()">更新</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="section1">
            <h4>【7】 代理商申请退款设置</h4>
            <el-row>
                <el-col :span="5">
                    <label>是否允许代理商退款：</label>
                    <el-radio-group v-model="agentState">
                        <el-radio label="1">开启</el-radio>
                        <el-radio label="0">停用</el-radio>
                    </el-radio-group>
                </el-col>
                <el-col :span="1">
                    <el-button type="primary" @click="updateAgentState()">更新</el-button>
                </el-col>
            </el-row>
        </div>


    </div>
</template>

<script>
import { getSecondBackInfo, updateSecondBackState, getBindPhoneInfo, updateBindPhoneState, secondBackDiagnose, querySecondBack, querySysConfigCoupon, updateSysConfigCoupon, queryCouponList, selectAdminCollectionConfig, adminCollectionConfig } from '@/api/customers.js'
import common from '@/utils/common.js'
export default {
    data() {
        return {
            collectPkcsFileName1: '',
            leshuaId: '',
            agentState: '',
            secondBackState: '',
            dayOfBack: 100,
            maxMoney: 5,
            bindState: 1,
            isUserOpen: '',
            isAdminOpen: '',
            day: 1,
            coupon: {
                "is_enable": 0,
                "id": null,
                "title": ''
            },
            couponList: [],
            loading: false,


            //收款配置
            collectionConfigShowData: {
                wxAppId: null,
                wxMchId: null,
                wxKeySign: null,
                wxAppSecret: null,
                collectPkcsUrl: null,
            },
            collectPkcsFileName: '',
            collectionConfigVisible: false,
            collectionConfigFormdata: {
                wxAppId: null,
                wxMchId: null,
                wxKeySign: null,
                wxAppSecret: null,
                p12: null,
                wxFile: '',
                collectPkcsUrl: null,
            },
            collectionConfigRules: {
                wxAppId: [
                    { required: true, message: '请输入wxAppId', trigger: 'blur' },
                ],
                wxMchId: [
                    { required: true, message: '请输入wxMchId', trigger: 'blur' },
                ],
                wxKeySign: [
                    { required: true, message: '请输入wxKeySign', trigger: 'blur' },
                ],
                wxAppSecret: [
                    { required: true, message: '请输入wxAppSecret', trigger: 'blur' },
                ],
            },

            //支付通道配置
            payChanle: [],

            //邮费配置
            postageForm: {
                is_enable: null,
                priceRmb: null,
                is_auto_back: null,
            },

            areaOption: [
                { name: '北京', key: 11 },
                { name: '天津', key: 12 },
                { name: '河北', key: 13 },
                { name: '山西', key: 14 },
                { name: '内蒙古', key: 15 },
                { name: '辽宁', key: 21 },
                { name: '吉林', key: 22 },
                { name: '黑龙江', key: 23 },
                { name: '上海', key: 31 },
                { name: '江苏', key: 32 },
                { name: '浙江', key: 33 },
                { name: '安徽', key: 34 },
                { name: '福建', key: 35 },
                { name: '江西', key: 36 },
                { name: '山东', key: 37 },
                { name: '河南', key: 41 },
                { name: '湖北', key: 42 },
                { name: '湖南', key: 43 },
                { name: '广东', key: 44 },
                { name: '广西', key: 45 },
                { name: '海南', key: 46 },
                { name: '重庆', key: 50 },
                { name: '四川', key: 51 },
                { name: '贵州', key: 52 },
                { name: '云南', key: 53 },
                { name: '西藏', key: 54 },
                { name: '陕西', key: 61 },
                { name: '甘肃', key: 62 },
                { name: '青海', key: 63 },
                { name: '宁夏', key: 64 },
                { name: '新疆', key: 65 },
                { name: '台湾', key: 71 },
                { name: '香港', key: 81 },
                { name: '澳门', key: 82 },
            ],//字典

            authenticationCinfig: {
                is_enable: 0,
                limit_area: null,
            },

            flowLimitConfig: {
                suppliers: null,
                datas: null,
                states: '0'
            },

            intoNoLimitConfig: {
                cofValue: null,
            },

            branchSupplierOption: [],//运营商字典
            rechargePermissions: {
                supplierIds: [],
            },


            simConfig: {
                type: null,
            },
            simTypeOptions: [{ id: '0', name: '秒嘀' }, { id: '1', name: '雁云' }],

            balanceRechargeLimit: {
                id: []
            },


            subId: '',
            subKey: '',
            subPwd: ''


        }
    },
    methods: {
        selectYy() {
            common.sysRequest("pkg/select/yy", {}, 'get').then(res => {
                if (res.data.code == 200) {
                   this.subId=res.data.data.subId;
                   this.subKey=res.data.data.subKey;
                   this.subPwd=res.data.data.subPwd;
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },
        updateYy() {
            common.sysRequest("pkg/update/yy", {subId:this.subId,subKey:this.subKey,subPwd:this.subPwd}, 'get').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message)
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

        updateSecondBackStateHandler() {
            let self = this;
            let req = { is_enable: self.secondBackState, day_of_back: self.dayOfBack, max_money: self.maxMoney };
            let data = {
                cofValue: JSON.stringify(req)
            };
            updateSecondBackState(data).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('设置成功')
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        updateBindPhoneStateHandler() {
            var data = {
                bindState: this.bindState
            }
            updateBindPhoneState(data).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message)
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        updateCouponInfoHandler() {
            let self = this;
            let param = {};
            param.coupon_id = self.coupon.id;
            param.id = self.coupon.id;
            param.is_enable = self.coupon.is_enable;
            param.title = self.coupon.title;
            let data = {
                cofValue: JSON.stringify(param)
            };

            updateSysConfigCoupon(data).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('设置成功')
                } else {
                    this.$message.error(res.data.message)
                }
            });
        },
        secondBackDiagnoseHandler() {
            const params = {
                isUserOpen: Number(this.isUserOpen),
                isAdminOpen: Number(this.isAdminOpen),
                day: this.day
            }
            //js对象转format-data
            const data = new FormData();
            Object.keys(params).forEach((key) => {
                data.append(key, params[key]);
            });
            secondBackDiagnose(data).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message)
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        updateAgentState() {
            var data = {
                state: this.agentState
            }
            common.sysRequest("agent/apply/state/update", data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    common.sysRequest("/agent/apply/state", {}, 'post').then(res => {
                        if (res.data.code == 200) {
                            this.agentState = res.data.data;
                        } else {
                            this.$message.error(res.data.message)
                        }
                    }).catch(err => console.error(err));
                } else {
                    this.$message.error(res.data.message)
                }

            }).catch(err => console.error(err));
        },
        getPostageConfig() {

        },

        updatePostageConfig() {
            let fd = new FormData();
            Object.keys(this.postageForm).forEach((key) => {
                fd.append(key, this.postageForm[key]);
            });
            common.sysRequest("sysConfig/postageOrder", fd, 'post').then(res => {
                if (res.data.code == 200) {
                    this.getPostageConfig();
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }

            }).catch(err => console.error(err));
        },
        querySecondBackDiagnose() {
            querySecondBack(null).then(res => {
                if (res.data.code == 200) {
                    this.isUserOpen = res.data.data.isUserOpen;
                    this.isAdminOpen = res.data.data.isAdminOpen;
                    this.day = res.data.data.day;
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        remoteMethod(query) {
            let self = this;
            if (query && query.length > 0) {
                self.loading = true;
                setTimeout(() => {
                    queryCouponList({ "titleLike": query }).then(res => {
                        if (res.data.code == 200) {
                            self.loading = false;
                            self.couponList = res.data.data;
                        }


                    }).catch(err => console.error(err));

                }, 200);

            }
        },

        //收款配置
        collectionConfigHandle() {
            this.$refs["collectionConfigForm"].validate((valid) => {
                if (valid) {
                    this.$confirm("确定保存新修改的数据吗？", "提示", {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        let formdata = new FormData();
                        Object.keys(this.collectionConfigFormdata).forEach((key) => {
                            formdata.append(key, this.collectionConfigFormdata[key]);
                        });

                        adminCollectionConfig(formdata).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message)
                                this.cancelToSetCollectionConfig();
                                //查询总部微信收款配置
                                this.getAdminCollectionConfig();
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    }).catch(() => {

                    });
                }
            });

        },
        //取消收款配置
        cancelToSetCollectionConfig() {
            for (let key in this.collectionConfigFormdata) {
                this.collectionConfigFormdata[key] = null;
            }
            document.getElementById('secondBack-uploadFile').value = '';
            this.collectPkcsFileName = '';
            this.collectionConfigVisible = false;
        },
        //选择证书文件
        chooseFile(event) {
            let files = event.target.files;
            let filename = files[0].name          //只有一个文件
            if (filename.lastIndexOf('.') <= 0) {
                return alert("Please add a valid image!")        //判断文件是否有效
            }
            let fileReader = new FileReader()                //内置方法new FileReader()   读取文件
            fileReader.readAsDataURL(files[0])
            this.collectionConfigFormdata.p12 = files[0];
            this.collectPkcsFileName = filename;
        },

        chooseFile1(event) {
            let files = event.target.files;
            let filename = files[0].name          //只有一个文件
            if (filename.lastIndexOf('.') <= 0) {
                return alert("Please add a valid image!")        //判断文件是否有效
            }
            let fileReader = new FileReader()                //内置方法new FileReader()   读取文件
            fileReader.readAsDataURL(files[0])
            this.collectionConfigFormdata.wxFile = files[0];
            this.collectPkcsFileName1 = filename;
        },

        //新增收款配置
        addCollectionConfig() {
            for (let key in this.collectionConfigFormdata) {
                this.collectionConfigFormdata[key] = null;
            }
            this.collectionConfigVisible = true;
        },

        //修改收款配置
        updateCollectionConfig() {
            //查询总部微信收款配置
            this.getAdminCollectionConfig();
            this.collectionConfigVisible = true;
        },

        getAdminCollectionConfig() {
            selectAdminCollectionConfig(new FormData()).then(res => {
                if (res.data.code == 200) {
                    if (res.data.data) {
                        for (let key in res.data.data) {
                            this.collectionConfigShowData[key] = res.data.data[key];
                            this.collectionConfigFormdata[key] = res.data.data[key];
                        }
                        this.collectionConfigFormdata.collectPkcsUrl = res.data.data.collectPkcsUrl;
                        this.collectionConfigShowData.collectPkcsUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.collectPkcsUrl;
                    }
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },

        //更新总部支付通道
        updatePayChannel() {
            let json = { cofValue: JSON.stringify(this.payChanle) }
            common.sysRequest("/sysConfig/pay/channel", json, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message)
                } else {
                    this.$message.error(res.data.message)
                }

            }).catch(err => console.error(err));
        },


        //查询实名认证配置
        getAuthentication() {
            common.sysRequest("sysConfig/auth/state/select", null, 'get').then(res => {
                if (res.data.code == 200) {
                    let d = JSON.parse(res.data.data.cofValue);
                    this.authenticationCinfig.is_enable = Number(d.is_enable);
                    this.authenticationCinfig.limit_area = d.limit_area.split(',').map(Number);
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

        //更改实名认证配置
        updateAuthentication() {
            let data = {
                is_enable: this.authenticationCinfig.is_enable,
                limit_area: this.authenticationCinfig.limit_area.join(",")
            }
            let formData = new FormData();
            Object.keys(data).forEach((key) => {
                formData.append(key, data[key]);
            });
            common.sysRequest("sysConfig/auth/state/update", formData, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                    this.getAuthentication();
                }
            }).catch(err => console.error(err));
        },


        //查询流量限额配置
        getFlowLimit() {
            common.sysRequest("sysConfig/sim/data/select", null, 'get').then(res => {
                if (res.data.code == 200) {
                    this.leshuaId = res.data.data;
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

        //更改流量限额配置
        updateFlowLimit() {
            let formData = new FormData();
            Object.keys(this.flowLimitConfig).forEach((key) => {
                formData.append(key, this.flowLimitConfig[key]);
            });
            formData.append("leshuaId", this.leshuaId);
            common.sysRequest("sysConfig/sim/data/update", formData, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                    this.getFlowLimit();
                }
            }).catch(err => console.error(err));
        },


        //查询接入号限制登录配置
        getIntoNoLimit() {
            common.sysRequest("sysConfig/sim/intono/select", null, 'get').then(res => {
                if (res.data.code == 200) {
                    this.intoNoLimitConfig = res.data.data;
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

        //更改接入号限制登录配置
        updateIntoNoLimit() {
            let cofValue = this.intoNoLimitConfig.cofValue;
            common.sysRequest("sysConfig/sim/intono/update", { cofValue: cofValue.replace(/，/g, ",") }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                    this.getIntoNoLimit();

                }
            }).catch(err => console.error(err));
        },



        //查询充值权限
        getRechargePermissions() {
            common.sysRequest("sysConfig/sim/invent/select", null, 'get').then(res => {
                if (res.data.code == 200) {
                    this.rechargePermissions.supplierIds = res.data.data.cofValue.split(",");
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

        //取消充值权限
        updateRechargePermissions() {
            let formData = new FormData();
            formData.append("supplierIds", this.rechargePermissions.supplierIds.join(","))
            common.sysRequest("sysConfig/sim/invent/update", formData, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                    this.getRechargePermissions();
                }
            }).catch(err => console.error(err));
        },




        //查询短信配置
        getSimConfig() {
            common.sysRequest("sysConfig/sms/select", null, 'get').then(res => {
                if (res.data.code == 200) {
                    this.simConfig.type = res.data.data.cofValue;
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => console.error(err));
        },

        //修改短信配置
        updateSimConfig() {
            let formData = new FormData();
            formData.append("type", this.simConfig.type)
            common.sysRequest("sysConfig/sms/update", formData, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                    this.getSimConfig();
                }
            }).catch(err => console.error(err));
        },

        //查询余额充值限制
        getBalanceRecharge() {
            common.sysRequest("/sysConfig/user/account", null, 'get').then(res => {
                if (res.data.code == 200) {
                    this.balanceRechargeLimit.id = res.data.data.cofValue.split(",");
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },

        //更新余额充值限制
        updateBalanceRecharge() {
            let formData = new FormData();
            formData.append("id", this.balanceRechargeLimit.id.join(","))
            common.sysRequest("sysConfig/update/account", formData, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                    this.getBalanceRecharge();
                }
            }).catch(err => console.error(err));
        },
        getPostageConfig() {
            common.sysRequest("sysConfig/postageOrder/query", null, 'post').then(res => {
                if (res.data.code == 200) {
                    for (let key in this.postageForm) {
                        this.postageForm[key] = res.data.data[key];
                    }
                } else {
                    this.$message.error(res.data.message)
                }

            }).catch(err => console.error(err));
        },


    },
    created() {
        this.selectYy();
        this.getPostageConfig();
        getSecondBackInfo({}).then(res => {
            if (res.data.code == 200) {
                let record = JSON.parse(res.data.data.cofValue);
                if (record) {
                    this.secondBackState = record.is_enable ? record.is_enable + '' : '0';
                    this.dayOfBack = record.day_of_back ? record.day_of_back : 0;
                    this.maxMoney = record.maxMoney ? record.maxMoney : 5;
                }
            } else {
                this.$message.error(res.data.message)
            }
        });

        getBindPhoneInfo({}).then(res => {
            if (res.data.code == 200) {
                this.bindState = res.data.data.bind_state;
            } else {
                this.$message.error(res.data.message);
            }
        });


        querySysConfigCoupon({}).then(res => {
            if (res.data.code == 200) {
                let record = JSON.parse(res.data.data.cofValue);
                if (record) {
                    this.couponList.push(record);
                    this.coupon = record;
                }
            } else {
                this.$message.error(res.data.message)
            }

        }).catch(err => console.error(err));

        this.querySecondBackDiagnose();

        //邮费配置
        this.getPostageConfig();

        //查询总部微信收款配置
        this.getAdminCollectionConfig();

        this.getAuthentication();
        this.getIntoNoLimit();
        this.getFlowLimit();
        this.getRechargePermissions();
        this.getSimConfig();
        this.getBalanceRecharge();

        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');


        //查询总部支付通道
        common.sysRequest("/sysConfig/pay/channel/select", null, 'post').then(res => {
            if (res.data.code == 200) {
                this.payChanle = JSON.parse(res.data.data.cofValue);
            } else {
                this.$message.error(res.data.message)
            }
        }).catch(err => console.error(err));
        //查询总部支付通道
        common.sysRequest("/agent/apply/state", {}, 'post').then(res => {
            if (res.data.code == 200) {
                this.agentState = res.data.data;
            } else {
                this.$message.error(res.data.message)
            }
        }).catch(err => console.error(err));



    }
}
</script>

<style lang="less" scoped>
#secondBack {
    font-size: 13px;

    h4 {
        color: #409eff;
        font-size: 13px;
        font-weight: bold;
        padding-left: 5px;
        margin-bottom: 20px;
        margin-left: -8px;
        border-left: 3px solid #409eff;
    }


    .section1,
    .section2 {
        margin-bottom: 50px;

        label {
            display: inline-block;
            line-height: 32px;
            vertical-align: middle;
        }
    }

    .section3 {
        margin-bottom: 50px;

        label {
            display: inline-block;
        }

        .el-row {
            margin-bottom: 20px;
        }

        span {
            text-align: left;
        }
    }




    .uploadFile {
        opacity: 0;
        height: 32px;
    }

    .toChooseFileBtn {
        position: absolute;
        left: 0;
        top: 0;
        background: none;
        border: 1px solid #DCDFE6;
        color: #606266;
        width: 80px;
        height: 32px;
        border-radius: 5px;
        text-align: center;
        font-size: 12px;
    }


    .section1,
    .section2,
    .section3 {
        padding-bottom: 10px;
        border-bottom: 1px solid #e8f0f5;
    }

}</style>

